export const StepCompletionEventNames = {
  listingCreation: 'Listing Creation' as const,
  instantRentCreation: 'Instant Rent Creation' as const
}

export type StepCompletionEventName =
  | typeof StepCompletionEventNames.listingCreation
  | typeof StepCompletionEventNames.instantRentCreation

export const ListingCreationSteps = {
  enteredFunnel: '0_entered_funnel' as const,
  filledContactDetails: '1_filled_contact_details' as const,
  filledListingDetails: '2_filled_listing_details' as const,
  proceededFromPhotos: '3_proceeded_from_photos' as const,
  submittedListing: '4_submitted_listing' as const
}

export type ListingCreationStep =
  | typeof ListingCreationSteps.enteredFunnel
  | typeof ListingCreationSteps.filledContactDetails
  | typeof ListingCreationSteps.filledListingDetails
  | typeof ListingCreationSteps.proceededFromPhotos
  | typeof ListingCreationSteps.submittedListing

export const InstantRentCreationSteps = {
  getAuthUrl: '0_get_auth_url' as const
}

export type InstantRentCreationStep =
  | typeof InstantRentCreationSteps.getAuthUrl
  | typeof ListingCreationSteps.filledContactDetails
